(function () {
  'use strict';
  const known = ['OCTPREMIUM', 'GREEN15'];
  class LinkOffer {
    constructor(owner) {
      this.owner = owner;
      this.code = this.readCode();
      this.active = false;
      this.labels = JSON.parse(owner.querySelector('[data-link-offer-labels]')?.textContent || '{}');
      this.urlHandler = () => {
        if (this.code !== this.readCode()) {
          owner.lock(); owner.addButton.disabled = true;
          owner.status.textContent = this.labels.refresh;
        }
      };
      window.addEventListener('popstate', this.urlHandler);
    }
    readCode() {
      const values = new URL(location.href).searchParams.getAll('et_offer');
      const code = values.length === 1 ? values[0].trim().toUpperCase() : '';
      return known.includes(code) ? code : '';
    }
    start() {
      const owner = this.owner;
      if (!this.code) return;
      this.active = owner.dataset.productId === '9886457856266' && owner.dataset.currency === 'GBP' && owner.pricingState.linkOffers[this.code] === true;
      const panel = owner.querySelector('[data-link-offer-panel]');
      if (panel) {
        panel.hidden = this.active && this.code === 'OCTPREMIUM';
        panel.querySelector('h3').textContent = this.active ? this.labels[this.code + '_title'] : this.labels.unavailable;
        panel.querySelector('p').textContent = this.active ? this.labels[this.code + '_hint'] : this.labels.unavailable_hint;
      }
      if (!this.active) return;
      owner.premium = true;
      owner.finish = owner.finishMap.premiumBlank;
      if (this.code === 'GREEN15') {
        owner.count = 3; owner.rows = ['Green', 'Green', 'Green'];
        owner.visibleColours = ['Green'];
      }
    }
    get freePremium() { return this.active && this.code === 'OCTPREMIUM' && [3,5,10].includes(this.owner.count); }
    get green() { return this.active && this.code === 'GREEN15'; }
    get contract() {
      return this.active && this.owner.premium && [3,5,10].includes(this.owner.count) ? this.code + ':1' : '1';
    }
    price(count, fallback) {
      if (!this.active || !this.owner.premium) return fallback;
      if (this.green && count === 3) return 1500;
      if (this.code === 'OCTPREMIUM' && [3,5,10].includes(count)) return this.owner.pricingState.prices.find(p=>p.count===count).standard;
      return fallback;
    }
    assertSelection() {
      if (this.code !== this.readCode()) throw new Error('pricing-changed');
      if (this.code && !this.active) throw new Error('offer-unavailable');
      if (this.green && (this.owner.count !== 3 || !this.owner.premium || this.owner.rows.slice(0,3).some(colour=>colour !== 'Green'))) throw new Error('pricing');
    }
    sync() {
      if (!this.code) return;
      const premium = this.owner.querySelector('.et-owned-premium');
      if (premium) premium.hidden = this.green;
      if (this.green) {
        this.owner.querySelectorAll('[data-owned-rows], .et-owned-usual').forEach(node=>{node.hidden=true;});
        this.owner.updateColourImage('Green');
      }
      if (!this.active) { this.owner.lock(); this.owner.addButton.disabled = true; }
    }
    async prepare() {
      this.assertSelection();
      if (this.contract === '1') return;
      const owner = this.owner, version = owner.version;
      const cart = await owner.fetchCart();
      const codes = [...new Set([...(cart.discount_codes || []).map(d=>d.code).filter(Boolean),this.code])];
      if (codes.length > 5) throw new Error('offer-unavailable');
      const url = new URL(owner.dataset.cartUrl + '/update.js',location.origin);
      if (url.origin !== location.origin) throw new Error('cart-url');
      const discountURL = new URL('discount/' + this.code,new URL('./',new URL(owner.dataset.cartUrl+'.js',location.origin)));
      discountURL.searchParams.set('redirect',owner.dataset.cartUrl+'.js');
      const nativeResponse = await fetch(discountURL.href,{credentials:'same-origin',cache:'no-store'});
      if (!nativeResponse.ok || owner.version !== version || !owner.isConnected) throw new Error('offer-unavailable');
      const response = await fetch(url.href,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:codes.join(',')})});
      if (!response.ok || owner.version !== version || !owner.isConnected) throw new Error('offer-unavailable');
      this.assertSelection();
    }
    destroy() { window.removeEventListener('popstate',this.urlHandler); }
  }
  window.EverteeLinkOffer = LinkOffer;
})();

(function () {
  'use strict';
  const tiers = Object.freeze({3: 1, 5: 2, 10: 3});
  const copy = value => JSON.parse(JSON.stringify(value));
  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const button = (label, action, value) => {
    const node = el('button', 'et-free-link', label);
    node.type = 'button';
    node.dataset.freeAction = action;
    if (value !== undefined) node.dataset.freeValue = String(value);
    return node;
  };
  class FreeTeeReview {
    constructor(owner) {
      this.owner = owner;
      this.labels = JSON.parse(owner.querySelector('[data-free-review-labels]').textContent);
      this.key = 'evertee-free-tees-review-v2:' + owner.dataset.reviewTheme;
      this.active = false;
      this.gifts = [];
      this.groups = [];
      this.editing = null;
      this.busy = false;
      this.requestVersion = 0;
      this.openButton = owner.querySelector('[data-free-open-basket]');
      this.feedback = owner.querySelector('[data-free-code-feedback]');
      this.giftPanel = owner.querySelector('[data-free-gifts]');
      this.giftRows = owner.querySelector('[data-free-gift-rows]');
      this.summary = owner.querySelector('[data-free-summary]');
      owner.addEventListener('click', event => this.onClick(event));
      this.urlHandler = () => { if (!this.busy) { this.readOfferURL(); this.save(); this.sync(); this.renderBasket(); } };
      window.addEventListener('popstate', this.urlHandler);
      this.dialog = el('dialog', 'et-free-dialog');
      this.dialog.setAttribute('aria-labelledby', owner.id + '-review-basket-title');
      this.dialog.addEventListener('click', event => this.onClick(event));
      this.dialog.addEventListener('close', () => this.openButton.focus({preventScroll:true}));
      document.body.append(this.dialog);
    }
    say(name, values = {}) {
      let result = this.labels[name] || name;
      for (const [key, value] of Object.entries(values)) result = result.replaceAll('__' + key + '__', String(value));
      return result;
    }
    start() {
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.key) || 'null');
        if (saved && saved.revision === this.owner.pricingState.revision && Array.isArray(saved.groups) && saved.groups.length <= 20) {
          this.active = saved.active === true;
          this.groups = saved.groups.filter(group => this.validGroup(group));
          if (!this.active) this.groups.forEach(group => { group.gifts = []; });
        }
      } catch (_) { this.groups = []; }
      this.readOfferURL();
      this.save();
      this.openButton.hidden = false;
      this.sync();
    }
    readOfferURL() {
      const values = new URL(location.href).searchParams.getAll('et_offer_preview');
      if (values.length) this.active = values.length === 1 && values[0].trim().toUpperCase() === 'PREVIEW';
      if (!this.active) { this.gifts = []; this.groups.forEach(group => { group.gifts = []; }); }
    }
    validGroup(group) {
      const owner = this.owner;
      if (!group || !owner.counts.includes(group.count) || typeof group.id !== 'string' || group.id.length > 50 ||
          typeof group.premium !== 'boolean' || typeof group.logo !== 'boolean' || !owner.sizes.includes(group.size) ||
          !Array.isArray(group.colours) || group.colours.length !== group.count || !group.colours.every(c => owner.visibleColours.includes(c)) ||
          !Array.isArray(group.gifts) || group.gifts.length > (tiers[group.count] || 0) ||
          !group.gifts.every(gift => gift && gift.size === group.size)) return false;
      const finish = owner.finishMap[(group.premium ? 'premium' : 'standard') + (group.logo ? 'Logo' : 'Blank')];
      return [...group.colours.map(colour => ({colour, size:group.size})), ...group.gifts].every(row =>
        row && owner.visibleColours.includes(row.colour) && owner.sizes.includes(row.size) &&
        owner.index.has(JSON.stringify([row.colour, row.size, finish])));
    }
    save() {
      try { sessionStorage.setItem(this.key, JSON.stringify({revision:this.owner.pricingState.revision, active:this.active, groups:this.groups})); }
      catch (_) { this.feedback.textContent = this.say('storage_warning'); }
    }
    removeOffer() {
      if (this.busy) return;
      this.active = false;
      this.gifts = [];
      this.groups.forEach(group => { group.gifts = []; });
      this.feedback.textContent = this.say('removed');
      const url = new URL(location.href);
      url.searchParams.delete('et_offer_preview');
      history.replaceState(history.state, '', url.href);
      this.owner.renderCounts(); this.owner.renderRows();
      this.save(); this.sync(); this.renderBasket();
    }
    sync() {
      if (!this.owner.catalog) return;
      ++this.requestVersion;
      const owner = this.owner;
      const allowance = this.active ? (tiers[owner.count] || 0) : 0;
      this.gifts = this.gifts.slice(0, allowance);
      while (this.gifts.length < allowance) this.gifts.push({colour:owner.rows[0] || owner.visibleColours[0],size:owner.size});
      this.gifts.forEach(gift => { gift.size = owner.size; });
      owner.querySelectorAll('[data-owned-count]').forEach(card => {
        const count = Number(card.dataset.ownedCount);
        let benefit = card.querySelector('[data-free-benefit]');
        if (!tiers[count]) return;
        if (count === 10) {
          const badge = card.querySelector('.et-owned-badge');
          const ribbon = card.parentElement.querySelector('.et-owned-ribbon');
          for (const [node,label] of [[badge,'large_bundle'],[ribbon,'three_free']]) {
            if (!node) continue;
            if (node.dataset.freeOriginal === undefined) node.dataset.freeOriginal = node.textContent;
            node.textContent = this.active ? this.say(label) : node.dataset.freeOriginal;
          }
        }
        if (!this.active) { benefit?.remove(); return; }
        if (!benefit) { benefit = el('span','et-free-benefit'); benefit.dataset.freeBenefit = ''; card.querySelector('.et-owned-card-content').append(benefit); }
        benefit.textContent = this.say(tiers[count] === 1 ? 'tier_one' : 'tier_unlocked', {N:tiers[count]});
      });
      document.querySelectorAll('[data-free-review-banner]').forEach(node => { node.hidden = !this.active; });
      document.querySelectorAll('[data-free-review-default-banner]').forEach(node => { node.hidden = this.active; });
      this.giftPanel.hidden = !allowance;
      owner.querySelector('[data-free-single-note]').hidden = !this.active || owner.count !== 1;
      owner.querySelector('[data-free-gift-title]').textContent = this.say(allowance === 1 ? 'choose_one' : 'choose_gifts',{N:allowance});
      owner.querySelector('[data-free-finish]').textContent = (owner.size ? this.say('matching_size',{SIZE:owner.size}) : this.say('matching_size_pending')) + ' · ' + this.finishLabel(owner);
      this.renderGifts();
      this.summary.textContent = this.say('summary',{PAID:owner.count,FREE:allowance,TOTAL:owner.count + allowance,PRICE:owner.money(owner.cardTotal(owner.count))});
      this.summary.hidden = !this.active;
      owner.addButton.textContent = this.editing ? this.say('save_bundle') : this.active ? this.say('add_total',{N:owner.count + allowance}) : this.say('add_preview');
      this.openButton.textContent = this.say('view_basket',{N:this.itemCount()});
      owner.wallet.hidden = true; owner.wallet.inert = true; owner.walletPrompt.hidden = true;
    }
    finishLabel(group) {
      return this.say(group.logo ? 'logo' : 'blank') + ' · ' + this.say(group.premium ? 'premium' : 'standard');
    }
    image(colour) {
      const image = el('img','et-free-photo');
      const source = this.owner.colourImages[colour];
      if (!source) { image.hidden = true; return image; }
      const url = new URL(source, location.origin);
      if (!['https:','http:'].includes(url.protocol)) { image.hidden = true; return image; }
      image.src = url.href; image.alt = colour + ' Evertee'; image.width = 80; image.height = 90; image.loading = 'lazy';
      return image;
    }
    renderGifts() {
      const owner = this.owner;
      this.giftRows.replaceChildren(...this.gifts.map((gift,index) => {
        const row = el('div','et-free-gift-row');
        row.append(this.image(gift.colour));
        const content = el('div','et-free-gift-content');
        const title = el('div','et-free-row-top');
        title.append(el('strong','',this.say('gift_number',{N:index+1})),el('strong','et-free-zero',owner.money(0)));
        content.append(title,el('div','et-owned-colour-label',gift.colour));
        const choices = el('div','et-owned-colours');
        owner.visibleColours.forEach(colour => {
          const choice = owner.button(colour,colour,'freeColour','et-owned-colour et-owned-colour--swatch');
          choice.dataset.freeRow = String(index);
          choice.setAttribute('aria-pressed',String(colour === gift.colour));
          choice.setAttribute('aria-label',this.say('gift_number',{N:index+1}) + ': ' + colour);
          choice.title = colour;
          choice.style.setProperty('--owned-swatch',owner.catalog.swatches[colour].color);
          const label = el('span','visually-hidden',colour); choice.replaceChildren(label); choices.append(choice);
        });
        content.append(choices); row.append(content); return row;
      }));
    }
    async add() {
      const owner = this.owner;
      if (this.busy || owner.busy || !owner.catalog) return false;
      if (!owner.size) { owner.showSizeError(); return false; }
      const attemptVersion = this.requestVersion;
      this.busy = true; owner.busy = true; owner.setBusy(true);
      owner.querySelectorAll('input,select').forEach(node => { node.disabled = true; });
      try {
        if (!await owner.refresh()) return false;
        const group = {id:this.editing || window.EverteeBundleCore.createBundleId(window.crypto),count:owner.count,size:owner.size,
          colours:owner.rows.slice(0,owner.count),logo:owner.logo,premium:owner.premium,gifts:copy(this.gifts)};
        if (!this.validGroup(group)) throw new Error('gift-selection');
        if (!this.editing && this.groups.length >= 20) throw new Error('too-many');
        const selections = [...group.colours.map(colour => ({colour,size:group.size})),...group.gifts];
        const quantities = new Map();
        selections.forEach(row => {
          const variant = owner.index.get(JSON.stringify([row.colour,row.size,owner.finish]));
          if (!variant) throw new Error('gift-selection');
          const current = quantities.get(String(variant.id)) || {variant,quantity:0};
          current.quantity++; quantities.set(String(variant.id),current);
        });
        await Promise.all([...quantities.values()].map(async ({variant,quantity}) => {
          const fresh = await owner.fetchVariant(variant);
          const rule = fresh.quantityRule;
          if (!fresh.available || !rule || quantity < rule.minimum || (rule.maximum != null && quantity > rule.maximum) || quantity % rule.increment !== 0) throw new Error('gift-stock');
        }));
        if (attemptVersion !== this.requestVersion || !owner.isConnected) return false;
        const index = this.groups.findIndex(item => item.id === group.id);
        if (index >= 0) this.groups[index] = group; else this.groups.push(group);
        this.editing = null; this.save();
        owner.status.textContent = this.say('added_preview');
        this.openBasket(); return true;
      } catch (error) {
        owner.status.textContent = this.say(error.message === 'too-many' ? 'too_many' : error.message === 'gift-selection' ? 'gift_selection_error' : error.message === 'pricing-changed' ? 'pricing_changed' : 'stock_error');
        return false;
      } finally {
        this.busy = false; owner.busy = false; owner.setBusy(false);
        owner.querySelectorAll('input,select').forEach(node => { node.disabled = false; });
        this.sync();
      }
    }
    price(group) {
      return this.owner.pricingState.prices.find(row => row.count === group.count)[group.premium ? 'premium' : 'standard'];
    }
    itemCount() { return this.groups.reduce((sum,group) => sum + group.count + group.gifts.length,0); }
    openBasket() {
      this.renderBasket();
      if (!this.dialog.open) this.dialog.showModal();
    }
    renderBasket() {
      const owner = this.owner;
      const header = el('div','et-free-basket-header');
      const heading = el('h2','',this.say('basket_title',{N:this.itemCount()})); heading.id = owner.id + '-review-basket-title';
      header.append(heading,button(this.say('close'),'close'));
      this.dialog.replaceChildren(header,el('p','et-free-preview-note',this.say('basket_notice')));
      const body = el('div','et-free-basket-body');
      if (!this.groups.length) body.append(el('p','',this.say('empty')));
      this.groups.forEach(group => {
        const card = el('section','et-free-basket-group'); card.dataset.reviewGroup = group.id;
        const top = el('div','et-free-row-top'); top.append(el('strong','',this.say('paid_bundle',{N:group.count})),el('strong','',owner.money(this.price(group))));
        card.append(top,el('p','et-free-detail',group.size + ' · ' + this.finishLabel(group)));
        const colours = new Map(); group.colours.forEach(colour => colours.set(colour,(colours.get(colour)||0)+1));
        const paid = el('div','et-free-paid-thumbs');
        colours.forEach((quantity,colour) => { const item = el('div'); item.append(this.image(colour),el('span','',quantity + ' × ' + colour)); paid.append(item); });
        card.append(paid);
        const actions = el('div','et-free-actions'); actions.append(button(this.say('edit'),'edit',group.id),button(this.say('remove_bundle'),'remove',group.id)); card.append(actions);
        group.gifts.forEach((gift,index) => {
          const giftRow = el('div','et-free-basket-gift'); giftRow.dataset.reviewGift = '';
          const details = el('div'); details.append(el('strong','',this.say('free_tee')),el('p','et-free-detail',gift.colour + ' · ' + gift.size + ' · ' + this.finishLabel(group)));
          details.append(button(this.say('remove_gift'),'remove-gift',group.id + ':' + index));
          giftRow.append(this.image(gift.colour),details,el('strong','et-free-tag',this.say('free')),el('strong','',owner.money(0))); card.append(giftRow);
        });
        if (this.active && tiers[group.count] && group.gifts.length < tiers[group.count]) card.append(button(this.say('claim',{N:tiers[group.count]-group.gifts.length}),'claim',group.id));
        body.append(card);
      });
      this.dialog.append(body);
      if (this.active) { const applied = el('div','et-free-basket-code'); applied.append(el('span','',this.say('applied')),button(this.say('remove_code'),'remove-code')); this.dialog.append(applied); }
      const subtotal = el('div','et-free-subtotal'); subtotal.append(el('strong','',this.say('subtotal')),el('strong','',owner.money(this.groups.reduce((sum,group) => sum + this.price(group),0))));
      this.dialog.append(subtotal,el('p','et-free-detail',this.say('delivery')));
      const end = el('button','button button--full-width button--primary',this.say('checkout_disabled')); end.type = 'button'; end.disabled = true;
      this.dialog.append(end,button(this.say('continue'),'close'));
    }
    edit(id,claim = false) {
      const group = this.groups.find(item => item.id === id); if (!group) return;
      if (claim && !this.active) return;
      const owner = this.owner;
      this.editing = id;
      owner.count = group.count; owner.size = group.size; owner.rows = group.colours.slice(); owner.premium = group.premium; owner.logo = group.logo;
      owner.finish = owner.finishMap[(group.premium?'premium':'standard') + (group.logo?'Logo':'Blank')];
      this.gifts = copy(group.gifts);
      owner.querySelectorAll('[data-owned-size]').forEach(node => node.setAttribute('aria-pressed',String(node.dataset.ownedSize === owner.size)));
      owner.renderCounts(); owner.renderRows(); owner.renderFinish(); owner.sizeError.hidden = true;
      this.sync(); this.save(); owner.refresh(); this.dialog.close();
      owner.querySelector('[data-owned-count="'+owner.count+'"]').focus({preventScroll:true});
    }
    onClick(event) {
      const target = event.target.closest('button');
      if (!target || this.busy) return;
      if (target.dataset.freeColour !== undefined) {
        event.preventDefault(); event.stopPropagation();
        const index = Number(target.dataset.freeRow);
        if (this.gifts[index] && this.owner.visibleColours.includes(target.dataset.freeColour)) {
          this.gifts[index].colour = target.dataset.freeColour; ++this.requestVersion; this.renderGifts();
          this.giftRows.querySelector('[data-free-row="'+index+'"][data-free-colour="'+target.dataset.freeColour+'"]').focus({preventScroll:true});
        }
        return;
      }
      const action = target.dataset.freeAction;
      if (!action) return;
      event.preventDefault(); event.stopPropagation();
      const id = target.dataset.freeValue;
      if (action === 'remove-code') this.removeOffer();
      if (action === 'open') this.openBasket();
      if (action === 'close') this.dialog.close();
      if (action === 'edit' || action === 'claim') this.edit(id, action === 'claim');
      if (action === 'remove') { this.groups = this.groups.filter(group => group.id !== id); if (this.editing === id) this.editing = null; this.save(); this.sync(); this.renderBasket(); }
      if (action === 'remove-gift') {
        const [groupId,index] = id.split(':'); const group = this.groups.find(group => group.id === groupId);
        if (group) group.gifts.splice(Number(index),1);
        this.save(); this.sync(); this.renderBasket();
      }
    }
    destroy() { window.removeEventListener('popstate', this.urlHandler); this.dialog.remove(); }
  }
  window.EverteeFreeTeeReview = FreeTeeReview;
})();

(function () {
  'use strict';
  const CODE = 'FREETEES';
  const CONTRACT = 'FREETEES:1';
  const KEY = 'evertee-free-tees-active-v1';

  // Reuses the approved gift colour controls and bundle card styling.
  // Prices and eligibility are independently checked by Shopify Functions.
  class FreeTeeOffer extends window.EverteeFreeTeeReview {
    constructor(owner) {
      super(owner);
      this.key = KEY;
      this.dialog.remove();
      this.openButton.hidden = true;
      this.nativeVersion = null;
      const originalURLHandler = this.urlHandler;
      window.removeEventListener('popstate', this.urlHandler);
      this.urlHandler = () => {
        if (owner.busy) return;
        owner.lock();
        originalURLHandler();
        owner.refresh();
      };
      window.addEventListener('popstate', this.urlHandler);
    }
    start() {
      try { this.active = sessionStorage.getItem(KEY) === CODE; } catch (_) {}
      this.readOfferURL(); this.save(); this.sync();
    }
    readOfferURL() {
      const values = new URL(location.href).searchParams.getAll('et_offer');
      if (values.length) this.active = values.length === 1 && values[0].trim().toUpperCase() === CODE;
      else if (this.owner.dataset.freeTeeCartOffer === CODE) this.active = true;
      if (!this.active) this.gifts = [];
    }
    save() {
      try {
        if (this.active) sessionStorage.setItem(KEY, CODE);
        else sessionStorage.removeItem(KEY);
      } catch (_) {}
    }
    sync() {
      if (!this.owner.catalog) return;
      // The base method builds colour controls. It never writes to Shopify.
      super.sync();
      this.openButton.hidden = true;
      this.owner.addButton.textContent = this.active
        ? this.say('add_total', {N:this.owner.count + this.gifts.length}) : this.say('add_normal');
      this.feedback.textContent = this.active ? this.say('offer_selected') : '';
      if (this.owner.ready && this.nativeVersion === this.requestVersion) {
        this.owner.wallet.hidden = false; this.owner.wallet.inert = false;
      }
      document.dispatchEvent(new CustomEvent('evertee:free-tees', {detail:{active:this.active}}));
    }
    async nativeBundle(bundle) {
      const version = this.requestVersion;
      const payload = bundle.toCartPayload();
      await this.prepare(payload);
      if (this.active && this.gifts.length) {
        // Native product checkout creates its own cart. Shopify's shareable
        // discount route also applies the code to that new checkout.
        const cartURL = new URL(this.owner.dataset.cartUrl + '.js', location.origin);
        const discountURL = new URL('discount/' + CODE, new URL('./', cartURL));
        discountURL.searchParams.set('redirect', cartURL.pathname);
        if (discountURL.origin !== location.origin) throw new Error('cart-url');
        const response = await fetch(discountURL.href, {credentials:'same-origin',cache:'no-store'});
        if (!response.ok) throw new Error('offer-unavailable');
        if (this.appliedCodes?.length > 1) {
          const restore = await fetch(new URL(this.owner.dataset.cartUrl + '/update.js',location.origin).href,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:this.appliedCodes.join(',')})});
          if (!restore.ok) throw new Error('offer-unavailable');
        }
      }
      if (version !== this.requestVersion || !this.owner.isConnected) throw new Error('gift-selection');
      const entries = [];
      payload.items.forEach((item, index) => {
        const field = name => index === 0 ? name : 'shopify-additional-items[' + index + '][' + name + ']';
        entries.push([field('id'), String(item.id)], [field('quantity'), String(item.quantity)]);
        const properties = Object.entries(item.properties || {});
        if (index === 0) properties.forEach(([key, value]) => entries.push(['properties[' + key + ']', value]));
        else entries.push([field('properties'), JSON.stringify(properties.map(([key, value]) => ({key, value})))]);
      });
      this.nativeVersion = version;
      return Object.freeze({
        ...bundle,
        toNativeFormEntries: () => entries.map(entry => entry.slice()),
        syncNativeForm: form => {
          window.EverteeBundleCore.clearNativeForm(form);
          const fragment = form.ownerDocument.createDocumentFragment();
          entries.forEach(([name, value]) => {
            const input = form.ownerDocument.createElement('input');
            input.type = 'hidden'; input.name = name; input.value = value;
            input.setAttribute('data-evertee-bundle-input', '');
            fragment.appendChild(input);
          });
          form.appendChild(fragment);
          return entries;
        }
      });
    }
    assertNativeReady() {
      if (this.nativeVersion !== this.requestVersion) throw new Error('gift-selection');
    }
    async prepare(payload) {
      if (!this.active || !this.gifts.length) return;
      const owner = this.owner;
      const attemptVersion = this.requestVersion;
      const expectedCount = {3:1,5:2,10:3}[owner.count];
      if (this.gifts.length !== expectedCount) throw new Error('gift-selection');
      const group = payload.items[0]?.properties?._et_bundle_id;
      const gifts = new Map();
      for (const gift of this.gifts) {
        const variant = owner.index.get(JSON.stringify([gift.colour,owner.size,owner.finish]));
        if (!variant) throw new Error('gift-selection');
        const id = String(variant.id);
        const item = gifts.get(id) || {id,quantity:0,properties:{_et_bundle_id:group,_et_bundle_count:'gift',_et_bundle_version:CONTRACT}};
        item.quantity++; gifts.set(id,item);
      }
      // Quantity rules and inventory apply to paid and free units together.
      const quantities = new Map();
      const cart = await owner.fetchCart();
      this.appliedCodes = [...new Set([...(cart.discount_codes || []).map(d=>d.code).filter(Boolean),CODE])];
      if (this.appliedCodes.length > 5) throw new Error('offer-unavailable');
      for (const item of [...cart.items,...payload.items,...gifts.values()]) {
        const id = String(item.variant_id ?? item.id);
        quantities.set(id,(quantities.get(id)||0)+item.quantity);
      }
      await Promise.all([...new Set([...payload.items,...gifts.values()].map(item=>String(item.id)))].map(async id=>{
        const variant = owner.catalog.variants.find(v=>String(v.id)===id);
        const fresh = await owner.fetchVariant(variant);
        const rule = fresh.quantityRule, quantity = quantities.get(id);
        if (!fresh.available || !rule || quantity < rule.minimum || (rule.maximum != null && quantity > rule.maximum) || quantity % rule.increment !== 0) throw new Error('gift-stock');
      }));
      if (attemptVersion !== this.requestVersion || !owner.isConnected) throw new Error('gift-selection');
      const url = new URL(owner.dataset.cartUrl + '/update.js',location.origin);
      if (url.origin !== location.origin) throw new Error('cart-url');
      const response = await fetch(url.href, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({discount:[...new Set([...(cart.discount_codes || []).map(d=>d.code).filter(Boolean),CODE])].join(','),attributes:{et_free_tees_offer:CODE}})});
      if (!response.ok) throw new Error('offer-unavailable');
      payload.items.push(...gifts.values());
    }
    openBasket() { this.owner.navigateTo(new URL(this.owner.dataset.cartUrl,location.origin).href); }
    renderBasket() {}
    onClick(event) {
      if (this.owner.busy) return;
      const before = this.requestVersion;
      super.onClick(event);
      if (this.requestVersion !== before && event.target.closest('[data-free-colour]')) this.owner.refresh();
    }
  }
  window.EverteeFreeTeeOffer = FreeTeeOffer;
})();

(function () {
  'use strict';
  const text = (node, value) => { if (node) node.textContent = value; };
  const integer = value => Number.isSafeInteger(value) && value >= 0;
  const keyFor = options => JSON.stringify(options);

  class EverteeOwnedBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.version = 0;
      this.busy = false;
      this.size = null;
      this.rows = [];
      this.pendingKey = 'evertee-owned-pending-v1:' + this.dataset.productId;
      this.form = this.querySelector('form[data-evertee-owned-bundle-form]');
      this.wallet = this.querySelector('[data-owned-wallet]');
      this.addButton = this.querySelector('[data-owned-add]');
      this.walletPrompt = this.querySelector('[data-owned-wallet-prompt]');
      this.status = this.querySelector('[data-owned-status]');
      this.sizeError = this.querySelector('[data-owned-size-error]');
      this.labels = JSON.parse(this.querySelector('[data-owned-labels]').textContent);
      this.colourImages = JSON.parse(this.querySelector('[data-owned-colour-images]')?.textContent || '{}');
      this.campaign = new window.EverteeLinkOffer(this);
      this.offer = this.dataset.freeTeeLive === 'true' ? new window.EverteeFreeTeeOffer(this) : null;
      this.addEventListener('click', event => this.onClick(event));
      this.addEventListener('change', event => event.stopPropagation());
      this.addEventListener('input', event => event.stopPropagation());
      this.form.addEventListener('submit', event => this.onSubmit(event));
      this.wallet.addEventListener('click', event => {
        try {
          this.assertNativeReady();
        } catch (error) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.lock();
          this.purchaseError(error);
        }
      }, true);
      this.visibilityHandler = () => {
        if (!document.hidden && this.catalog) this.refresh();
      };
      document.addEventListener('visibilitychange', this.visibilityHandler);
      this.lock();
      this.load();
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.expiryTimer);
      document.removeEventListener('visibilitychange', this.visibilityHandler);
      this.offer?.destroy();
      this.campaign?.destroy();
    }

    say(name) { return this.labels[name] || this.labels.retry; }

    ownedPricingActive() {
      return this.dataset.ownedPricingActive === 'true' && this.dataset.ownedPricingVersion === '1' &&
        this.catalog?.pricing?.engine === 'evertee-owned-v1' && this.pricingState?.active === true;
    }

    readPricingState(value) {
      if (!value || typeof value.active !== 'boolean' || value.version !== '1' ||
          value.productId !== this.dataset.productId || value.currency !== this.dataset.currency ||
          typeof value.revision !== 'string' || !value.revision || value.revision.length > 128 ||
          /[|\r\n]/.test(value.revision) || typeof value.freePremium !== 'boolean' ||
          !Array.isArray(value.prices) || value.prices.length !== this.counts.length) throw new Error('pricing');
      const hasPremium = Boolean(this.finishMap.premiumBlank);
      const freePremium = value.freePremium && ['9886457856266', '10630781042954'].includes(this.dataset.productId);
      const prices = this.counts.map(count => {
        const matches = value.prices.filter(price => price.count === count);
        if (matches.length !== 1) throw new Error('pricing');
        const price = matches[0];
        if (!integer(price.standard) || price.standard <= 0 ||
            price.standard > this.catalog.pricing.unitCentsByFinish[this.finishMap.standardBlank] * count ||
            (hasPremium && (!integer(price.premium) || price.premium <= 0 ||
              price.premium > this.catalog.pricing.unitCentsByFinish[this.finishMap.premiumBlank] * count)) ||
            (!hasPremium && price.premium != null) ||
            (freePremium && price.premium !== price.standard)) throw new Error('pricing');
        return {count, standard: price.standard, ...(hasPremium ? {premium: price.premium} : {})};
      });
      return {active: value.active, version: '1', productId: value.productId, currency: value.currency,
        revision: value.revision, freePremium: value.freePremium, linkOffers:{OCTPREMIUM:value.linkOffers?.OCTPREMIUM===true,GREEN15:value.linkOffers?.GREEN15===true}, prices};
    }

    freePremiumActive() {
      if (this.campaign?.freePremium) return true;
      return this.pricingState?.active === true && this.pricingState.freePremium &&
        ['9886457856266', '10630781042954'].includes(this.dataset.productId);
    }

    assertCurrentPricing(value) {
      const current = this.readPricingState(value);
      if (!current.active) throw new Error('pricing');
      if (JSON.stringify(current) !== JSON.stringify(this.pricingState)) throw new Error('pricing-changed');
    }

    newPending() {
      const next = {id: window.EverteeBundleCore.createBundleId(window.crypto), state: 'prepared'};
      this.savePending(next);
    }

    readPending() {
      const saved = window.sessionStorage.getItem(this.pendingKey);
      if (!saved) { this.newPending(); return; }
      const value = JSON.parse(saved);
      window.EverteeBundleCore.bundleProperties(value.id, 1);
      if (!['prepared', 'submitting', 'uncertain', 'rejected'].includes(value.state) ||
          (value.state !== 'prepared' && (!Array.isArray(value.items) || !value.items.length ||
          !Number.isSafeInteger(value.totalCents) || value.currency !== this.dataset.currency))) {
        throw new Error('pending-storage');
      }
      if (value.items && (!window.EverteeBundleCore.exactItems(value.items, value.items) ||
          value.items.some(item => item.properties._et_bundle_id !== value.id))) throw new Error('pending-storage');
      this.pending = value;
    }

    savePending(value = this.pending) {
      window.sessionStorage.setItem(this.pendingKey, JSON.stringify(value));
      this.pending = value;
    }

    rememberAttempt(items, totalCents) {
      this.pending = {...this.pending, state: 'submitting', items, totalCents, currency: this.dataset.currency};
      this.savePending();
    }

    async fetchCart(signal) {
      const url = new URL(this.dataset.cartUrl + '.js', location.origin);
      if (url.origin !== location.origin) throw new Error('cart-url');
      const response = await fetch(url.href, {credentials: 'same-origin', cache: 'no-store', signal,
        headers: {Accept: 'application/json'}});
      if (!response.ok) throw new Error('cart-fetch');
      return response.json();
    }

    async recoverAttempt() {
      if (!this.pending || this.pending.state === 'prepared') return false;
      const cart = await this.fetchCart();
      const result = window.EverteeBundleCore.inspectCartGroup(cart, this.pending.items,
        this.pending.totalCents, this.pending.currency);
      if (result.state === 'exact') {
        this.newPending();
        return true;
      }
      if (result.state === 'mismatch') throw new Error('bundle-cart-mismatch');
      if (this.pending.state !== 'rejected') throw new Error('bundle-add-uncertain');
      this.pending = {id: this.pending.id, state: 'prepared'};
      this.savePending();
      return false;
    }

    purchaseError(error) {
      if (['bundle-cart-mismatch', 'bundle-add-uncertain'].includes(error.message)) {
        text(this.status, this.say(error.message === 'bundle-cart-mismatch' ? 'bundleNeedsReview' : 'addUnconfirmed') + ' ');
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl;
        link.textContent = this.say('reviewBag');
        this.status.append(link);
        if (this.pending?.state !== 'prepared') {
          const retry = document.createElement('button');
          retry.type = 'button';
          retry.className = 'button button--secondary';
          retry.dataset.ownedReviewComplete = '';
          retry.textContent = this.say('bagReviewed');
          this.status.append(document.createTextNode(' '), retry);
        }
      } else text(this.status, error.message === 'pricing-changed' ? this.say('pricingChanged') :
        error.message === 'pricing' ? this.say('pricingUnverified') : this.say('addFailed'));
    }

    async recoverAfterBagReview() {
      if (this.busy || !this.pending?.items) return;
      this.busy = true;
      this.setBusy(true);
      this.lock();
      try {
        const cart = await this.fetchCart();
        const group = window.EverteeBundleCore.inspectCartGroup(cart, this.pending.items,
          this.pending.totalCents, this.pending.currency);
        if (group.state === 'mismatch') throw new Error('bundle-cart-mismatch');
        if (group.state === 'exact') this.newPending();
        else {
          this.pending = {id: this.pending.id, state: 'prepared'};
          this.savePending();
        }
        if (await this.refresh()) text(this.status, this.say(group.state === 'exact' ? 'added' : 'readyToRetry'));
      } catch (error) {
        this.purchaseError(error.message === 'bundle-cart-mismatch' ? error : new Error('bundle-add-uncertain'));
      } finally {
        this.busy = false;
        this.setBusy(false);
      }
    }

    assertNativeReady() {
      this.campaign?.assertSelection();
      this.offer?.assertNativeReady();
      if (!this.ready || this.busy || !this.ownedPricingActive() || this.pricingExpired() ||
          this.pending?.state !== 'prepared') throw new Error('pricing');
      const action = new URL(this.form.action, location.origin);
      const expected = new URL(this.dataset.cartAddUrl, location.origin);
      if (action.origin !== location.origin || action.pathname !== expected.pathname || action.search !== expected.search || action.hash ||
          this.form.method.toLowerCase() !== 'post') throw new Error('native-form');
      window.EverteeBundleCore.assertNativeEntries(this.form, this.bundle.toNativeFormEntries());
    }

    lock() {
      this.ready = false;
      this.bundle = null;
      this.wallet.hidden = true;
      this.wallet.inert = true;
      this.walletPrompt.hidden = true;
      const total = this.querySelector('[data-owned-total-wrap]');
      if (total) total.hidden = true;
      window.EverteeBundleCore?.clearNativeForm(this.form);
    }

    async load() {
      try {
        const url = new URL(this.dataset.catalogUrl, location.origin);
        if (!['https:', 'http:'].includes(url.protocol)) throw new Error('catalog-url');
        const response = await fetch(url.href, {credentials: 'same-origin'});
        if (!response.ok) throw new Error('catalog-fetch');
        const catalog = await response.json();
        if (String(catalog.productId) !== this.dataset.productId || !Array.isArray(catalog.variants) ||
            catalog.variants.length !== Number(this.dataset.variantCount)) throw new Error('catalog-identity');
        this.catalog = catalog;
        this.readPending();
        this.counts = JSON.parse(this.dataset.allowedCounts);
        this.count = Number(this.dataset.initialCount);
        this.colours = catalog.colours;
        this.visibleColours = catalog.visibleColours || catalog.colours.filter(colour => !['Pale Blue', 'Ash Rose', 'Sand'].includes(colour));
        this.sizes = catalog.sizes;
        this.finishes = catalog.finishes;
        this.finishMap = catalog.finishMap;
        if (!this.finishMap?.standardBlank || !this.finishes.includes(this.finishMap.standardBlank)) throw new Error('finish-map');
        this.pricingState = this.readPricingState(JSON.parse(this.querySelector('[data-owned-pricing-state]').textContent));
        this.logo = false;
        this.premium = this.freePremiumActive();
        this.finish = this.finishMap[this.premium ? 'premiumBlank' : 'standardBlank'];
        this.index = new Map(catalog.variants.map(variant => [keyFor(variant.options), variant]));
        this.rows = Array.from({length: this.count}, () => catalog.initialColour || null);
        this.campaign?.start();
        this.makeBundle(catalog.variants);
        this.watchExpiry();
        this.renderSizes();
        this.renderCounts();
        this.renderRows();
        this.renderFinish();
        text(this.status, '');
        this.addButton.disabled = false;
        this.walletPrompt.disabled = false;
        this.dataset.loaded = 'true';
        this.offer?.start();
        this.campaign?.sync();
      } catch (error) {
        this.lock();
        text(this.status, this.say('retry'));
        this.dataset.loadError = 'true';
      }
    }

    makeBundle(variants) {
      const bundle = window.EverteeBundleCore.createBundle({
        variants, colours: this.colours, sizes: this.sizes, finishes: this.finishes,
        allowedCounts: this.counts, initialCount: this.count, initialColour: null,
        initialFinish: this.finish, allowedProperties: window.EverteeBundleCore.bundlePropertyKeys
      });
      this.rows.slice(0, this.count).forEach((colour, index) => bundle.setColour(index, colour));
      if (this.size !== null) bundle.setSize(this.size);
      bundle.setProperties({...window.EverteeBundleCore.bundleProperties(this.pending.id, this.count),_et_bundle_version:this.campaign?.contract || '1'});
      return bundle;
    }

    button(value, label, attribute, className) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.dataset[attribute] = String(value);
      button.setAttribute('aria-pressed', 'false');
      button.textContent = label;
      return button;
    }

    renderSizes() {
      const target = this.querySelector('[data-owned-sizes]');
      target.replaceChildren(...this.sizes.map(size => this.button(size, size, 'ownedSize', 'et-owned-pill')));
    }

    renderCounts() {
      const target = this.querySelector('[data-owned-counts]');
      target.replaceChildren(...(this.campaign?.green ? [3] : this.counts).map(count => {
        const selected = count === this.count;
        const tier = this.catalog.tiers[String(count)];
        const card = document.createElement('div');
        card.className = 'et-owned-card';
        card.dataset.selected = String(selected);
        const label = count === 1 ? this.say('bundleSingle') : this.say('bundlePlural').replaceAll('__ET_COUNT__', String(count));
        const button = this.button(count, '', 'ownedCount', 'et-owned-pack');
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('aria-expanded', String(selected));
        button.setAttribute('aria-controls', this.id + '-colours-' + count);
        const radio = document.createElement('span');
        radio.className = 'et-owned-radio';
        radio.setAttribute('aria-hidden', 'true');
        const content = document.createElement('span');
        content.className = 'et-owned-card-content';
        const titleLine = document.createElement('span');
        titleLine.className = 'et-owned-card-title-line';
        const title = document.createElement('span');
        title.className = 'et-owned-card-title';
        title.textContent = label;
        titleLine.append(title);
        const total = this.cardTotal(count);
        if (tier.badge) {
          const badge = document.createElement('span');
          badge.className = 'et-owned-badge';
          badge.textContent = tier.badge === 'mostPopular' ? this.say('mostPopular') : this.say('perTee').replaceAll('__ET_PRICE__', this.money(Math.floor(total / count)));
          titleLine.append(badge);
        }
        content.append(titleLine);
        if (tier.usualBaseCents) {
          const usual = document.createElement('span');
          usual.className = 'et-owned-usual';
          usual.textContent = this.say('usually').replaceAll('__ET_PRICE__', this.money(tier.usualBaseCents + (this.premium ? count * this.catalog.pricing.premiumExtraCents : 0), true));
          content.append(usual);
        }
        const price = document.createElement('span');
        price.className = 'et-owned-price';
        price.textContent = this.money(total);
        button.append(radio, content, price);
        card.append(button);
        if (tier.ribbon) {
          const ribbon = document.createElement('span');
          ribbon.className = 'et-owned-ribbon';
          ribbon.textContent = this.say(tier.ribbon);
          card.append(ribbon);
        }
        const rows = document.createElement('div');
        rows.id = this.id + '-colours-' + count;
        rows.className = 'et-owned-rows';
        rows.hidden = !selected;
        if (selected) rows.dataset.ownedRows = '';
        card.append(rows);
        return card;
      }));
    }

    money(cents, trim = false) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency', currency: this.dataset.currency,
        minimumFractionDigits: trim ? 0 : 2, maximumFractionDigits: 2
      }).format(cents / 100);
    }

    cardTotal(count) {
      const price = this.pricingState?.prices.find(price => price.count === count);
      const total = this.campaign?.price(count,price?.[this.premium ? 'premium' : 'standard']) ?? price?.[this.premium ? 'premium' : 'standard'];
      if (!integer(total)) throw new Error('pricing');
      return total;
    }

    renderRows() {
      const target = this.querySelector('[data-owned-rows]');
      target.replaceChildren(...this.rows.slice(0, this.count).map((selected, index) => {
        const field = document.createElement('div');
        field.className = 'et-owned-colour-row';
        field.setAttribute('role', 'group');
        const legend = document.createElement('div');
        legend.className = 'et-owned-colour-label';
        legend.id = this.id + '-colour-label-' + index;
        field.setAttribute('aria-labelledby', legend.id);
        legend.textContent = this.say('colourLabel').replaceAll('__ET_COLOUR__', selected || '');
        const number = document.createElement('span');
        number.className = 'et-owned-row-number';
        number.textContent = '#' + (index + 1);
        number.setAttribute('aria-hidden', 'true');
        const content = document.createElement('div');
        content.className = 'et-owned-row-content';
        const choices = document.createElement('div');
        choices.className = 'et-owned-colours';
        this.visibleColours.forEach(colour => {
          const button = this.button(colour, colour, 'ownedColour', 'et-owned-colour');
          button.dataset.ownedRow = String(index);
          button.setAttribute('aria-pressed', String(colour === selected));
          button.setAttribute('aria-label', this.say('teeNumber').replaceAll('__ET_NUMBER__', String(index + 1)) + ': ' + colour);
          const swatch = this.catalog.swatches?.[colour];
          if (swatch?.color && CSS.supports('color', swatch.color)) {
            button.classList.add('et-owned-colour--swatch');
            button.style.setProperty('--owned-swatch', swatch.color);
            button.title = colour;
            const label = document.createElement('span');
            label.className = 'visually-hidden';
            label.textContent = colour;
            button.replaceChildren(label);
          }
          choices.appendChild(button);
        });
        content.append(legend, choices);
        field.append(number, content);
        return field;
      }));
    }

    updateColourImage(colour) {
      const source = this.colourImages?.[colour];
      if (!source) return;
      const gallery = this.closest('product-info')?.querySelector('media-gallery');
      if (typeof gallery?.setColourImage === 'function') gallery.setColourImage(source, colour);
    }

    renderFinish() {
      this.querySelectorAll('[data-owned-logo]').forEach(button => {
        button.setAttribute('aria-pressed', String((button.dataset.ownedLogo === 'true') === this.logo));
      });
      const premium = this.querySelector('[data-owned-premium]');
      premium?.setAttribute('aria-checked', String(this.premium));
      premium?.setAttribute('aria-label', this.say(this.freePremiumActive() ? 'premiumFreeTitle' : 'premiumTitle'));
      text(this.querySelector('[data-owned-premium-title]'), this.say(this.freePremiumActive() ? 'premiumFreeTitle' : 'premiumTitle'));
      text(this.querySelector('[data-owned-premium-price]'), this.say(this.freePremiumActive() ? 'premiumFreePrice' : 'premiumPrice'));
      const description = this.querySelector('[data-owned-premium-description]');
      if (description) description.hidden = this.freePremiumActive();
    }

    onClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-owned-review-complete')) {
        event.preventDefault();
        event.stopPropagation();
        if (event.isTrusted) this.recoverAfterBagReview();
        return;
      }
      if (button.matches('[data-owned-add], [data-owned-wallet-prompt]')) {
        event.stopPropagation();
        if (button.matches('[data-owned-wallet-prompt]')) {
          event.preventDefault();
          if (!this.size) this.showSizeError();
          else this.refresh();
        }
        return;
      }
      const isChoice = button.matches('[data-owned-size], [data-owned-colour], [data-owned-count], [data-owned-logo], [data-owned-premium]');
      if (!isChoice) return;
      if (this.campaign?.green && button.matches('[data-owned-count], [data-owned-colour], [data-owned-premium]')) { event.preventDefault(); event.stopPropagation(); return; }
      event.preventDefault();
      event.stopPropagation();
      if (!event.isTrusted || !this.catalog || this.busy) return;
      if (this.pending?.state !== 'prepared') { this.purchaseError(new Error('bundle-add-uncertain')); return; }
      if (button.dataset.ownedSize !== undefined) {
        this.size = button.dataset.ownedSize;
        this.sizeError.hidden = true;
        this.querySelector('[data-owned-size-field]').classList.remove('et-owned-size-required');
        this.querySelectorAll('[data-owned-size]').forEach(node => {
          node.setAttribute('aria-pressed', String(node.dataset.ownedSize === this.size));
          node.removeAttribute('aria-invalid');
        });
      } else if (button.dataset.ownedColour !== undefined) {
        const rowIndex = Number(button.dataset.ownedRow);
        this.rows[rowIndex] = button.dataset.ownedColour;
        const field = button.closest('.et-owned-colour-row');
        field.querySelectorAll('[data-owned-colour]').forEach(choice => {
          choice.setAttribute('aria-pressed', String(choice.dataset.ownedColour === button.dataset.ownedColour));
        });
        text(field.querySelector('.et-owned-colour-label'), this.say('colourLabel').replaceAll('__ET_COLOUR__', button.dataset.ownedColour));
        this.updateColourImage(button.dataset.ownedColour);
      } else if (button.dataset.ownedCount !== undefined) {
        this.count = Number(button.dataset.ownedCount);
        while (this.rows.length < this.count) this.rows.push(this.catalog.initialColour || null);
        this.renderCounts();
        this.renderRows();
        this.querySelector('[data-owned-count="' + this.count + '"]')?.focus({preventScroll: true});
      } else {
        if (button.dataset.ownedLogo !== undefined) this.logo = button.dataset.ownedLogo === 'true';
        else this.premium = !this.premium;
        this.finish = this.finishMap[(this.premium ? 'premium' : 'standard') + (this.logo ? 'Logo' : 'Blank')];
        this.renderFinish();
        this.renderCounts();
        this.renderRows();
        if (button.hasAttribute('data-owned-premium') && this.premium &&
            !matchMedia('(prefers-reduced-motion: reduce)').matches &&
            typeof window.showPremiumCongratulationsOverlay === 'function') {
          window.showPremiumCongratulationsOverlay();
        }
      }
      this.renderFinish();
      this.offer?.sync();
      this.campaign?.sync();
      this.refresh();
    }

    showSizeError() {
      this.sizeError.hidden = false;
      const field = this.querySelector('[data-owned-size-field]');
      field.classList.add('et-owned-size-required');
      const first = field.querySelector('button');
      first?.setAttribute('aria-invalid', 'true');
      first?.setAttribute('aria-describedby', this.sizeError.id);
      field.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center'});
      first?.focus({preventScroll: true});
    }

    selectedVariants() {
      if (!this.size) throw new Error('size');
      if (!this.finishes.includes(this.finish)) throw new Error('finish');
      const found = new Map();
      this.rows.slice(0, this.count).forEach(colour => {
        if (!colour) throw new Error('colour');
        const variant = this.index.get(keyFor([colour, this.size, this.finish]));
        if (!variant) throw new Error('variant');
        found.set(String(variant.id), variant);
      });
      return [...found.values()];
    }

    async fetchVariant(variant, signal) {
      const url = new URL(this.dataset.productUrl, location.origin);
      url.searchParams.set('variant', variant.id);
      url.searchParams.set('section_id', this.dataset.variantSection || this.dataset.sectionId);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      const response = await fetch(url.href, {credentials: 'same-origin', signal, cache: 'no-store'});
      if (!response.ok) throw new Error('variant-fetch');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const node = html.querySelector('[data-et-owned-selected-variant]');
      if (!node) throw new Error('variant-data');
      const current = JSON.parse(node.textContent);
      this.assertCurrentPricing(current.ownedPricing);
      if (String(current.productId) !== this.dataset.productId || current.currency !== this.dataset.currency || !current.variant ||
          String(current.variant.id) !== String(variant.id) ||
          keyFor(current.variant.options) !== keyFor(variant.options) ||
          typeof current.variant.available !== 'boolean' || !integer(current.variant.price)) throw new Error('variant-mismatch');
      if (current.variant.price !== this.catalog.pricing.unitCentsByFinish[this.finish]) throw new Error('pricing');
      return {...current.variant, id: String(current.variant.id)};
    }

    pricingTotal(bundle, variants) {
      const pricing = this.catalog.pricing;
      if (!this.ownedPricingActive() || this.dataset.pricingReady !== 'true' || pricing?.verified !== true ||
          (pricing.currency || this.catalog.currency) !== this.dataset.currency || this.pricingExpired() ||
          !integer(pricing.discountCentsByCount?.[this.count])) throw new Error('pricing');
      const prices = new Map(variants.map(variant => [String(variant.id), variant.price]));
      const gross = bundle.resolve().items.reduce((sum, line) => sum + prices.get(line.id) * line.quantity, 0);
      const total = this.cardTotal(this.count);
      if (!integer(gross) || !integer(total) || total > gross) throw new Error('pricing');
      return total;
    }

    pricingExpired() {
      if (this.ownedPricingActive() && !this.catalog.pricing.endsAt) return false;
      const ends = Date.parse(this.catalog?.pricing?.endsAt || '');
      return !Number.isFinite(ends) || Date.now() >= ends;
    }

    watchExpiry() {
      clearTimeout(this.expiryTimer);
      const remaining = Date.parse(this.catalog?.pricing?.endsAt || '') - Date.now();
      if (!(remaining > 0)) return;
      this.expiryTimer = setTimeout(() => {
        if (this.pricingExpired()) {
          ++this.version;
          this.controller?.abort();
          this.lock();
          text(this.status, this.say('pricingUnverified'));
        } else this.watchExpiry();
      }, Math.min(remaining, 2147483647));
    }

    async refresh() {
      const version = ++this.version;
      this.controller?.abort();
      this.controller = new AbortController();
      this.lock();
      this.querySelector('[data-owned-total-wrap]').hidden = true;
      if (!this.catalog || !this.size) { text(this.status, ''); return false; }
      text(this.status, this.say('checking'));
      try {
        if (!this.ownedPricingActive()) throw new Error('pricing');
        if (this.pending?.state !== 'prepared') throw new Error('bundle-add-uncertain');
        const selected = this.selectedVariants();
        const fresh = await Promise.all(selected.map(variant => this.fetchVariant(variant, this.controller.signal)));
        if (version !== this.version || !this.isConnected) return false;
        const byId = new Map(fresh.map(variant => [variant.id, variant]));
        const catalog = this.catalog.variants.map(variant => byId.get(String(variant.id)) || variant);
        let bundle = this.makeBundle(catalog);
        const total = this.pricingTotal(bundle, fresh);
        const currentCart = await this.fetchCart(this.controller.signal);
        if (version !== this.version || !this.isConnected) return false;
        const group = window.EverteeBundleCore.inspectCartGroup(currentCart, bundle.toCartPayload().items, total, this.dataset.currency);
        if (group.state !== 'absent') throw new Error('bundle-cart-mismatch');
        await this.campaign?.prepare();
        if (version !== this.version || !this.isConnected) return false;
        if (this.offer) bundle = await this.offer.nativeBundle(bundle);
        if (version !== this.version || !this.isConnected) return false;
        bundle.syncNativeForm(this.form);
        this.verifiedTotal = total;
        this.bundle = bundle;
        this.ready = true;
        text(this.status, '');
        text(this.querySelector('[data-owned-total]'), new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style: 'currency', currency: this.dataset.currency}).format(total / 100));
        this.querySelector('[data-owned-total-wrap]').hidden = false;
        this.wallet.hidden = false;
        this.wallet.inert = false;
        this.walletPrompt.hidden = true;
        return true;
      } catch (error) {
        if (version !== this.version || error.name === 'AbortError') return false;
        this.lock();
        if (['bundle-cart-mismatch', 'bundle-add-uncertain'].includes(error.message)) { this.purchaseError(error); return false; }
        text(this.status, error.message === 'pricing-changed' ? this.say('pricingChanged') :
          error.message === 'pricing' ? this.say('pricingUnverified') :
          error.message === 'colour' ? this.say('chooseAll') :
          ['VARIANT_UNAVAILABLE', 'QUANTITY_RULE', 'VARIANT_NOT_FOUND'].includes(error.code) || ['variant', 'finish'].includes(error.message) ? this.say('unavailable') : this.say('retry'));
        return false;
      }
    }

    async onSubmit(event) {
      const submitter = event.submitter;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (submitter !== this.addButton) return;
      if (this.busy || !this.catalog) return;
      if (!this.size && this.pending?.state === 'prepared') { this.showSizeError(); return; }
      this.busy = true;
      this.setBusy(true);
      let mutationStarted = false;
      let confirmed = false;
      let destination;
      try {
        const target = this.dataset.cartUrl;
        if (!target) throw new Error('checkout-url');
        const next = new URL(target, location.origin);
        if (next.origin !== location.origin) throw new Error('checkout-url');
        destination = next.href;
        if (!this.ownedPricingActive()) throw new Error('pricing');
        if (await this.recoverAttempt()) {
          text(this.status, this.say('added'));
          this.navigateTo(destination);
          return;
        }
        if (!await this.refresh()) return;
        const payload = this.bundle.toCartPayload();
        await this.campaign?.prepare();
        await this.offer?.prepare(payload);
        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const redirect = Boolean(this.campaign?.active) || Boolean(this.offer?.active) || (typeof window.everteeShouldRedirectAfterAdd === 'function' && window.everteeShouldRedirectAfterAdd());
        if (cart && !redirect && typeof cart.getSectionsToRender === 'function') {
          payload.sections = cart.getSectionsToRender().map(section => section.id);
          payload.sections_url = location.pathname;
          cart.setActiveElement?.(document.activeElement);
        }
        this.wallet.hidden = true;
        this.wallet.inert = true;
        const url = new URL(this.dataset.cartAddUrl + '.js', location.origin);
        if (url.origin !== location.origin) throw new Error('cart-url');
        this.rememberAttempt(payload.items, this.verifiedTotal);
        mutationStarted = true;
        const response = await fetch(url.href, {
          method: 'POST', credentials: 'same-origin', headers: {'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: JSON.stringify(payload)
        });
        if (!response.ok) {
          this.pending.state = response.status >= 400 && response.status < 500 ? 'rejected' : 'uncertain';
          this.savePending();
          throw new Error('cart-add');
        }
        const result = await response.json();
        if (!window.EverteeBundleCore.exactItems(result.items, payload.items)) throw new Error('cart-response');
        const currentCart = await this.fetchCart();
        const group = window.EverteeBundleCore.inspectCartGroup(currentCart, payload.items, this.verifiedTotal, this.dataset.currency);
        if (group.state !== 'exact') throw new Error(group.state === 'absent' ? 'bundle-add-uncertain' : 'bundle-cart-mismatch');
        confirmed = true;
        this.newPending();
        text(this.status, this.say('added'));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          await publish(PUB_SUB_EVENTS.cartUpdate, {source:'evertee-owned-bundle',productVariantId:payload.items[0].id,cartData:result});
        }
        if (cart && !redirect && typeof cart.renderContents === 'function' && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents({...result.items[0], ...result});
          await this.refresh();
        } else this.navigateTo(destination);
      } catch (error) {
        this.lock();
        if (confirmed) {
          this.navigateTo(destination);
          return;
        }
        if (mutationStarted) {
          if (this.pending.state !== 'rejected') this.pending.state = 'uncertain';
          try { this.savePending(); } catch (_) {}
          try {
            if (await this.recoverAttempt()) {
              text(this.status, this.say('added'));
              this.navigateTo(destination);
              return;
            }
          } catch (recoveryError) { error = recoveryError; }
          if (this.pending.state !== 'prepared') {
            this.purchaseError(error.message === 'bundle-cart-mismatch' ? error : new Error('bundle-add-uncertain'));
            return;
          }
        }
        this.purchaseError(error);
      } finally {
        this.busy = false;
        this.setBusy(false);
        this.offer?.sync();
        this.campaign?.sync();
      }
    }

    navigateTo(destination) {
      location.assign(destination);
    }

    setBusy(busy) {
      this.setAttribute('aria-busy', String(busy));
      this.querySelectorAll('button').forEach(button => { button.disabled = busy; });
    }
  }
  if (!customElements.get('evertee-owned-bundle')) customElements.define('evertee-owned-bundle', EverteeOwnedBundle);
})();



